import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { RootState } from '../Store/Store'

export interface MediaRequest {
  name: string,
  title?: string,
  image: any,
  type: string
}

export const mediaApi = createApi({
  reducerPath: 'mediaApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api/media',
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token
      if (token) {
        headers.set('authorization', `Bearer ${token}`)
      }
      return headers
    },
  }),
  tagTypes: ['media'],

  endpoints: (builder) => ({
    getAllMedia: builder.query({
      query: () => '/',
      providesTags: ['media']
    }),
    uploadMedia: builder.mutation({
      query: (data) => ({
        url: '/upload',
        method: 'POST',
        body: data,
        formData: true,
      }),
      invalidatesTags: ['media']
    }),
    deleteMedia: builder.mutation<any, number>({
      query: (id) => ({
        url: `/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['media']
    }),
  }),
})

export const { useGetAllMediaQuery , useDeleteMediaMutation , useUploadMediaMutation } = mediaApi